import { useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { KeyRound } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";

const EMPTY = { current_password: "", new_password: "", confirm: "" };

export const ChangePasswordDialog = () => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const set = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) return toast.error("New passwords don't match");
    setSaving(true);
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: form.current_password, new_password: form.new_password }, { withCredentials: true });
      toast.success("Password updated");
      setForm(EMPTY);
      setOpen(false);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "New password must be at least 8 characters");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button className="w-full flex items-center gap-3 px-4 py-3 text-gray-400 hover:bg-gray-800 rounded transition-colors" data-testid="change-password-btn">
          <KeyRound className="w-5 h-5" /> <span className="font-medium">Change Password</span>
        </button>
      </DialogTrigger>
      <DialogContent className="rounded-none max-w-md">
        <DialogHeader><DialogTitle className="font-heading uppercase">Change Password</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
          {[["current_password", "Current password"], ["new_password", "New password (min 8 characters)"], ["confirm", "Confirm new password"]].map(([name, label]) => (
            <div key={name}>
              <label className="text-sm font-medium">{label}</label>
              <Input type="password" name={name} value={form[name]} onChange={set} required minLength={name === "current_password" ? 1 : 8} className="rounded-none" data-testid={`change-password-${name.replace("_", "-")}`} />
            </div>
          ))}
          <button type="submit" disabled={saving} className="btn-abfa-primary w-full disabled:opacity-50" data-testid="change-password-submit">
            <span>{saving ? "Saving..." : "Update Password"}</span>
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
